import { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

interface PaywalToastProps {
  title?: string;
  description: string;
  refresh?: boolean;
  type?: 'success' | 'error';
}

export const PaywallToast = (props: PaywalToastProps) => {
  const { title, description, refresh, type = 'success' } = props;

  const handleRefresh = useCallback(() => {
    window.location.reload();
    const currentHref = window.location.href;
    const updatedHref = currentHref
      .replace(/[?&]after_purchase=[^&]*/, '')
      .replace(/[?&]trial_activated=[^&]*/, '')
      .replace(/[&?]$/, '');
    window.location.href = updatedHref;
  }, []);

  const icon = useMemo(() => {
    if (type === 'success') {
      return (
        <div className="inline-flex items-center justify-center w-9 h-9 bg-green-100 rounded-full flex-shrink-0">
          <Icon icon={IconsMap.CHECK_CIRCLE} className="text-green-500 w-5 h-5" />
        </div>
      );
    }
    if (type === 'error') {
      return (
        <span className="inline-flex items-center justify-center w-9 h-9 bg-red-100 rounded-full flex-shrink-0">
          <Icon icon={IconsMap.ALERT_CIRCLE} className="text-red-500 w-5 h-5" />
        </span>
      );
    }
  }, [type]);

  return (
    <div
      className={classNames('flex text-sm gap-3 text-left', {
        'items-center': !title,
      })}
    >
      {icon}
      <div>
        {title ? <div className="font-bold text-neutral-800 mb-2">{title}</div> : null}
        <div className="text-neutral-500">{description}</div>
        {refresh ? (
          <div className="text-cyan-900 font-bold text-[13px] cursor-pointer mt-2" onClick={handleRefresh}>
            Refresh now
          </div>
        ) : null}
      </div>
    </div>
  );
};
